import { Typography } from "@povio/ui";
import { cx } from "class-variance-authority";

import { ChevronRightIcon } from "@/assets/icons/general/ChevronRight";

export const UserDropdownItem = ({
  label,
  onClick,
  variant = "default",
}: {
  label: string;
  onClick: () => void;
  variant?: "default" | "destructive";
}) => (
  <div
    role="button"
    tabIndex={0}
    className={cx(
      "flex cursor-pointer flex-row items-center justify-between gap-3 p-4 outline-hidden",
      "hover:bg-interactive-contained-secondary-idle active:bg-interactive-contained-secondary-pressed",
      variant === "destructive" && "text-interactive-contained-error-idle",
    )}
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick();
      }
    }}
  >
    <Typography
      size="label-2"
      className="flex-1"
    >
      {label}
    </Typography>
    <ChevronRightIcon className="h-4 w-4 shrink-0" />
  </div>
);
